/**** NPM Package Source https://github.com/Hacker0x01/react-datepicker ****/
/*********  https://github.com/react-component/time-picker ********/

import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from 'moment';

import './DatePickerStyle.scss';

class mtxDatePicker extends Component {

    // componentDidUpdate(){
    //       console.log(this.props.minValue);
    // if(this.props.minValue){
          
    //      var val1  = this.props.minValue === "today"?Moment().toDate(): new Moment(this.props.minValue).toDate();
    //      this.setState({val:val1})
    //     }
    // }
       
    state = {
        start_date: new Date(),
        selected: null,
        val: undefined
    }

    onDateChange = (date) => {
        console.log(date)
        this.setState({
            start_date: date,
            selected: date
        })
        if(this.props.handleLangChange){
            this.props.handleLangChange(date)
  
        }


    }

    render() {
                    // console.log(this.props.minValue);

        if(this.props.minValue){
            var val1  = this.props.minValue === "today"?Moment().toDate(): new Moment(this.props.minValue).toDate();

        }
        if(this.props.defaultValue){
            if(!this.state.selected){
                this.setState({selected:Moment(this.props.defaultValue).toDate()})
            }
        }

        // console.log(this.state.val);
        return (
            <DatePicker
                startDate={this.state.start_date}
                onChange={this.onDateChange}
                selected={this.props.defaultValue === ""?"":this.state.selected}
                popperPlacement="top"
                dateFormat="dd/MM/yyyy"   
		      minDate={val1 ? val1:null}

                popperClassName={this.props.className}
                className={this.props.className}
                placeholderText={this.props.placeholder}
            />
        )
    }
}

export default mtxDatePicker;
